import { render } from "./FCdit.vue?vue&type=template&id=2ddf1ddd&scoped=true"
import script from "./FCdit.vue?vue&type=script&lang=js"
export * from "./FCdit.vue?vue&type=script&lang=js"

import "./FCdit.vue?vue&type=style&index=0&id=2ddf1ddd&lang=scss&scoped=true"
import "./FCdit.vue?vue&type=style&index=1&id=2ddf1ddd&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ddf1ddd"]])

export default __exports__